import React, { useState, useEffect } from 'react';
import { chordLibrary } from '../constants';

export default function SettingsModal({ 
  isOpen, 
  onClose, 
  activeChords, 
  setActiveChords, 
  capo, 
  setCapo, 
  currentTone, 
  setTone,
  currentChord
}) {
  const [presets, setPresets] = useState({});
  const [activeTab, setActiveTab] = useState('library'); // 'library' or 'presets'

  useEffect(() => {
    const p = localStorage.getItem('guitarPresets');
    if (p) setPresets(JSON.parse(p));
  }, [isOpen]);

  const toggleChord = (chord) => {
    let newChords;
    if (activeChords.includes(chord)) {
      newChords = activeChords.filter(c => c !== chord);
    } else {
      newChords = [...activeChords, chord];
    }
    
    // Ensure at least one chord
    if(newChords.length === 0) newChords = ['C'];
    
    setActiveChords(newChords);
  };

  const savePreset = () => {
    const name = prompt("Enter preset name:", activeChords.join(" - "));
    if (name && name.trim()) {
      const newPresets = { ...presets, [name.trim()]: { chords: activeChords, capo } };
      setPresets(newPresets);
      localStorage.setItem("guitarPresets", JSON.stringify(newPresets));
    }
  };

  const loadPreset = (name) => {
    const data = presets[name];
    if (data.chords) {
      setActiveChords(data.chords);
      setCapo(data.capo || 0);
    } else {
      // Legacy support if just array
      setActiveChords(data);
      setCapo(0);
    }
  };

  const deletePreset = (name, e) => {
    e.stopPropagation();
    if (confirm("Delete preset?")) {
      const newPresets = { ...presets };
      delete newPresets[name];
      setPresets(newPresets);
      localStorage.setItem("guitarPresets", JSON.stringify(newPresets));
    }
  };

  if (!isOpen) return null;

  return (
    <div id="settings-modal" style={{ display: 'flex' }}>
      <div className="modal-content">
        <div className="modal-header">
          <span className="modal-title">Settings</span>
          <span className="close-icon" onClick={onClose}>✕</span>
        </div>
        
        <div className="tabs-header">
          <button 
            className={`tab-btn ${activeTab === 'library' ? 'active' : ''}`}
            onClick={() => setActiveTab('library')}
          >
            Library
          </button>
          <button 
            className={`tab-btn ${activeTab === 'presets' ? 'active' : ''}`}
            onClick={() => setActiveTab('presets')}
          >
            Presets
          </button>
        </div>

        <div className="tab-content" style={{ display: activeTab === 'library' ? 'block' : 'none' }}>
          <div className="settings-row compact">
             <div className="setting-group">
                <div className="setting-label compact-label">Capo</div>
                <div className="capo-controls compact-controls">
                  <button className="capo-btn compact-btn" onClick={() => setCapo(Math.max(0, capo - 1))}>-</button>
                  <span id="capo-display" className="compact-display">{capo === 0 ? "0" : `+${capo}`}</span>
                  <button className="capo-btn compact-btn" onClick={() => setCapo(Math.min(12, capo + 1))}>+</button>
                </div>
             </div>
             
             <div className="setting-group">
                <div className="setting-label compact-label">Tone</div>
                <div className="sound-options compact-controls">
                  <button 
                    className={`sound-btn compact-btn ${currentTone === 'acoustic' ? 'selected' : ''}`} 
                    onClick={() => setTone('acoustic')}>Acoustic</button>
                  <button 
                    className={`sound-btn compact-btn ${currentTone === 'distortion' ? 'selected' : ''}`} 
                    onClick={() => setTone('distortion')}>Rock</button>
                </div>
             </div>
          </div>

          <div className="chord-library-container">
            <div className="library-header">
              <span className="setting-label">Chord Library</span>
            </div>
            <div className="chord-grid" id="library-grid">
              {Object.keys(chordLibrary).sort().map(chord => (
                 <button 
                   key={chord}
                   className={`lib-btn ${activeChords.includes(chord) ? 'added' : ''} ${
                     chord.includes('#') || chord.includes('b') ? 'sharp' : chord.includes('m') ? 'minor' : ''
                   }`}
                   onClick={() => toggleChord(chord)}
                 >
                   {chord}
                 </button>
              ))}
            </div>
          </div>
          
          <button className="action-btn save-preset-btn" onClick={savePreset}>Save Currently Selected as Preset</button>
        </div>
        
        <div className="tab-content" style={{ display: activeTab === 'presets' ? 'block' : 'none' }}>
          <div className="preset-controls">
            <div className="setting-label">Saved Presets</div>
            <div id="preset-list">
              {Object.keys(presets).length === 0 ? (
                 <div style={{color:'#666', fontSize:'0.8rem', fontStyle:'italic', textAlign: 'center', padding: '20px'}}>No saved presets</div>
              ) : (
                Object.keys(presets).map(name => (
                  <div key={name} className="preset-item">
                    <span className="preset-name" onClick={() => loadPreset(name)}>{name}</span>
                    <button className="preset-del" onClick={(e) => deletePreset(name, e)}>✕</button>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
}
